import React, { useEffect, useRef } from 'react';
import { history } from 'umi';
// import { IS_WOA } from '@/pages/home/_config/config';
import './index.scss';
import { buriedPointPage } from '@/pages/home/utils/buriedPoint';
import { PageLogMes } from '@/pages/home/utils/buriedPointCfg';

// const chatgptUrl = IS_WOA ? 'https://databrain-chatgpt.woa.com/en' : 'http://iegg-gpt.intlgame.com:8080/en';
const chatgptUrl = '/iegg/chatgpt/en';

export default () => {
  // 页面初始化的时候，传url上面的参数给子iframe，后续不再更新，Next框架是服务端渲染, 如果url地址变化，会重新触发页面js执行，也就是会reload....
  const initialUrlParams = useRef('');
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const queryString = params.toString();
    initialUrlParams.current = queryString;
  }, []);
  
  useEffect(() => {
    buriedPointPage(PageLogMes.chatgpt);
    // 监听message事件
    window.addEventListener('message', receiveMessageFromIndex);
    // 组件卸载时清理事件监听器
    return () => {
      window.removeEventListener('message', receiveMessageFromIndex);
    };
  }, []);
  
  // 接受数据
  const receiveMessageFromIndex= (params: any)=> {
    if (params?.data && params?.data?.type === 'chatGpt') {
      history.replace({
        pathname: `/chatgpt`,
        query: {
          chatId: params?.data?.value,
        }
      });
    }
  };

  return (
    <div className="dth-chatgpt-container">
      <iframe
        className="dth-chatgpt-iframe"
        src={`${chatgptUrl}?${initialUrlParams.current}`}
        frameBorder="0"
      />
    </div>
  );
};
